import React from 'react'
import VideosList from '@share/components/videos/List/VideosList'
import VideosType from '@share/components/videos/Type/VideoType'
import VideosUpload from '@share/components/videos/Upload/VideoUpload'

const VideoList: React.FC<{}> = () => (
  <div className="main-content">
    <ul className="nav nav-tabs" id="StoreInformationTab" role="tablist">
      <li className="nav-item">
        <a className="nav-link active" id="StoreInformation-BasicInformation-tab" data-toggle="tab" href="#StoreInformation-BasicInformation" role="tab" aria-controls="BasicInformation" aria-selected="true">動画一覧</a>
      </li>
      <li className="nav-item">
        <a className="nav-link" id="StoreInformation-PriceRangeCategory-tab" data-toggle="tab" href="#StoreInformation-PriceRangeCategory" role="tab" aria-controls="PriceRangeCategory" aria-selected="false">動画カテゴリ</a>
      </li>
      <li className="nav-item">
        <a className="nav-link" id="StoreInformation-ReviewsManagement-tab" data-toggle="tab" href="#StoreInformation-ReviewsManagement" role="tab" aria-controls="ReviewsManagement" aria-selected="false">アップロード</a>
      </li>
    </ul>
    <div className="tab-content" id="StoreInformationTabContent">
      <VideosList />
      <VideosType />
      <VideosUpload />
    </div>
  </div>
)

export default VideoList
